import { Vehicle } from "@/interfaces";
import { useEffect } from "react";
import { useMap } from "react-leaflet";

interface VehicleMapControllerProps {
  vehicles: Vehicle[] | undefined;
  selectedVehicleId: number | undefined;
}
const VehicleMapController = ({
  vehicles,
  selectedVehicleId,
}: VehicleMapControllerProps) => {
  const map = useMap();

  // You can use effects to control the map based on selected vehicles
  useEffect(() => {
    if (selectedVehicleId && vehicles) {
      const vehicle = vehicles.find((v) => v.id === selectedVehicleId);
      if (vehicle?.last_position) {
        map.setView(
          [vehicle.last_position.latitude, vehicle.last_position.longitude],
          15,
        );
      }
    }
  }, [map, selectedVehicleId, vehicles]);

  return null;
};

export default VehicleMapController;
